import { IoSchool } from "react-icons/io5";
import { useGlobalContext } from "./context/globalContext";
import { useState, useRef, useEffect } from "react";
import { MdHealthAndSafety } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { FaMapLocation } from "react-icons/fa6";

const LocationBenefits2 = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  const [activeDetail, setActiveDetail] = useState(null);
  const detailsRef = useRef(null);

  // Handle click outside to close details
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the details and the icon
      if (
        detailsRef.current &&
        !detailsRef.current.contains(event.target) &&
        !event.target.closest(".benefit-icon")
      ) {
        setActiveDetail(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle icon click
  const handleIconClick = (index, event) => {
    event.stopPropagation();
    setActiveDetail(activeDetail === index ? null : index);
  };
  const benefits = [
    {
      icon: <IoSchool />,
      title: "Educational Institutes",
      details: [
        "SIES High Scl - 1km",
        "Trinity Intl Scl - 1.8km",
        "RIMS Intl Scl - 3.5km",
        "SIES College - 0.5km",
        "University of Mumbai - 3km",
      ],
    },
    {
      icon: <MdHealthAndSafety />,
      title: "Hospitals",
      details: [
        "Lokmanya Tilak Hospital - 2km",
        "K. J. Somaiya Hospital - 2.4km",
        "Wadia Hospital - 5.2km",
        "Global Hospital, Parel - 4.8km",
        "Lilavati Hospital, Bandra - 9.3km",
      ],
    },
    {
      icon: <FaShoppingCart />,
      title: "Malls",
      details: [
        "Five Gardens Dadar - 2.4km",
        "Wadala IMAX Dome - 3km",
        "Phoenix Marketcity - 6.3km",
        "Palladium Mall - 7.5km",
        "High Street Phoenix - 7.5km",
      ],
    },
    {
      icon: <FaMapLocation />,
      title: "Connectivity",
      details: [
        "Metro Line 3 Stn* - 1.2km",
        "Sion Flyover - 1.3km",
        "Eastern Express Hwy - 1.5km",
        "Sion Railway Stn - 1.8km",
        "Chunabhatti Stn, Harbour - 2km",
        "Bandra Kurla Complex (BKC) - 5.5km",
        "Lower Parel - 7.2km",
      ],
    },
  ];
  return (
    <>
      <div className="section shadow-sm lazyloaded">
        <div className="lb-container">
          <div className="lb-map">
            <img src="/images/lb.PNG" alt="Location Overview" />
          </div>
          <div className="lb-content">
            <div className="lb-content-body">
              <h2 className="head text-capitalize text-center">
                {project} - Location & Connectivity
              </h2>
              <div className="cards">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    className={`crd position-${index + 1}  ${
                      activeDetail === index ? "alive-card" : ""
                    } `}
                  >
                    <div
                      className="crd-icon"
                      onClick={(e) => handleIconClick(index, e)}
                    >
                      {benefit.icon}
                      <span className="crd-title">{benefit.title}</span>
                    </div>
                    <div
                      ref={activeDetail === index ? detailsRef : null}
                      className={`crd-details ${
                        activeDetail === index ? "active" : ""
                      }`}
                      id="card-details-scroll"
                    >
                      <ul>
                        {/* {benefit.details.map((detail, idx) => (
                          <li key={idx}>{detail}</li>
                        ))} */}
                        {benefit.details.map((detail, idx) => {
                          const parts = detail.split(" - "); // Using " - " (en dash) for separation
                          if (parts.length === 2) {
                            return (
                              <li key={idx}>
                                <span>{parts[0]}</span>

                                <span>{parts[1]}</span>
                              </li>
                            );
                          } else {
                            return <li key={idx}>{detail}</li>; // Handle cases with no " - "
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lb-content-footer">
              <span className="new-button " onClick={handleShowModal}>
                <span className="new-button-inner">
                  <span className="underline-animation">Get All Details</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocationBenefits2;
